(function () {
  /**
   * @param {HTMLElement} section
   */
  function initReviewsSection(section) {
    const toggle = section.querySelector('[data-sw-reviews-toggle]');
    const footer = section.querySelector('[data-sw-reviews-footer]');
    const cards = Array.from(section.querySelectorAll('[data-sw-review-card]'));
    if (!toggle || !cards.length) return;

    const initialVisible = Number.parseInt(section.dataset.initialVisible, 10) || 6;
    const loadIncrement = Number.parseInt(section.dataset.loadIncrement, 10) || 6;
    const moreLabel = section.dataset.moreLabel || 'See more reviews';

    let visibleCount = Math.min(initialVisible, cards.length);

    const updateVisibility = () => {
      cards.forEach((card, index) => {
        card.classList.toggle('sw-reviews__card--hidden', index >= visibleCount);
      });

      const hasMore = visibleCount < cards.length;
      if (footer) footer.hidden = !hasMore;
      toggle.setAttribute('aria-expanded', hasMore ? 'false' : 'true');
      toggle.textContent = moreLabel;
    };

    toggle.addEventListener('click', () => {
      visibleCount = Math.min(visibleCount + loadIncrement, cards.length);
      updateVisibility();

      const firstNewCard = cards[visibleCount - loadIncrement] || cards[visibleCount - 1];
      if (firstNewCard && visibleCount < cards.length) {
        firstNewCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    updateVisibility();
  }

  document.querySelectorAll('.sw-reviews[data-initial-visible]').forEach((section) => {
    if (section instanceof HTMLElement) initReviewsSection(section);
  });
})();
